<template>
  <div>
    <!-- 卖场轮播图开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <div class="actRules">
        <p v-html="modulesRulesChange"></p>
      </div>
    </div>
    <!-- 卖场轮播图结束-->
  </div>
</template>

<script>
import '../../assets/css/reset.css';
export default {
	name: 'h5-rules',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			modulesRules: '规则描述'
		}
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字'
		},
		modulesRules: {
			type: String,
			default:
        '活动规则：规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案'
		}
	},
	mounted () {},
	computed: {
		modulesRulesChange () {
			let string = this.modulesRules;
			string = string.replace(/\r\n/g, '<br>');
			string = string.replace(/\n/g, '<br>');
			return string;
		}
	},
	methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common";

.sellBanner {
  width: 7.3rem;
  margin: 0 auto;

  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/localCom/x-rules.vue